import { useContext } from 'react';
import { SetEditorContext } from './index';

export function useSetEditor() {
  const context = useContext(SetEditorContext);
  if (!context) {
    throw new Error(
      'useSetEditor must be used within SetEditorContextProvider',
    );
  }
  return context;
}
